import React from "react";
import { Drawer, Tooltip } from "antd";
import { Spinner, Table } from "reactstrap";
import CurrencyFormat from "react-currency-format";
const moment = require("moment");

const getTruckImage = (trucktype) => {
  try {
    return `https://media.qiktruck.co.za/3d-${trucktype}.png`;
  } catch (error) {
    return "";
  }
};

const truncate = (s, n) =>
  !s ? "-" : s.length > n ? s.substring(0, n) + "..." : s;

/**
 * Side drawer showing a driver's recent trips.
 * Per-trip actions: Open (triggers onOpenTrip) and Duplicate (triggers onDuplicateTrip).
 */
const DriverTripsDrawer = ({
  driver,
  trips = [],
  loading = false,
  onClose,
  onOpenTrip,
  onDuplicateTrip,
}) => {
  return (
    <Drawer
      open={!!driver}
      onClose={onClose}
      placement="right"
      width={720}
      title={
        driver ? (
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <img
              src={getTruckImage(driver.trucktype)}
              alt=""
              height="32"
            />
            <div>
              <div style={{ fontWeight: "bold", fontSize: 15 }}>
                {driver.firstname} {driver.lastname}
              </div>
              <div
                style={{
                  fontSize: 11,
                  color: "#777",
                  fontWeight: "normal",
                }}
              >
                {driver.trucktype} · {driver.licensenumber} · {driver.trips}{" "}
                trips
              </div>
            </div>
          </div>
        ) : null
      }
    >
      {driver && (
        <div>
          <h5 style={{ fontSize: 14, marginBottom: 8 }}>Last 10 trips</h5>
          {loading && (
            <div className="spinner-parent">
              <div className="spinner">
                <Spinner /> trips
              </div>
            </div>
          )}
          {!loading && trips.length === 0 && (
            <div
              style={{
                textAlign: "center",
                padding: 20,
                color: "#999",
              }}
            >
              No recent trips found for this driver
            </div>
          )}
          {trips.length > 0 && (
            <Table striped>
              <thead>
                <tr>
                  <th>Order</th>
                  <th>Date</th>
                  <th>Route</th>
                  <th>Price</th>
                  <th>Status</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {trips.map((t) => (
                  <tr key={t.orderid}>
                    <td>
                      <b>{t.orderid.split("-")[0]}</b>
                    </td>
                    <td>
                      <div style={{ fontSize: 12 }}>
                        {moment(new Date(t.collectiondate)).format(
                          "MMM DD, YYYY"
                        )}
                      </div>
                      <div style={{ fontSize: 11, color: "#999" }}>
                        {t.collectiontime}
                      </div>
                    </td>
                    <td style={{ fontSize: 12 }}>
                      <div>
                        <i
                          className="mdi mdi-map-marker"
                          style={{ color: "green" }}
                        ></i>{" "}
                        {truncate(t.collectionaddress, 28)}
                      </div>
                      <div>
                        <i
                          className="mdi mdi-map-marker-check"
                          style={{ color: "red" }}
                        ></i>{" "}
                        {truncate(t.deliveryaddress, 28)}
                      </div>
                    </td>
                    <td>
                      <CurrencyFormat
                        value={t.sellingprice / 100}
                        displayType={"text"}
                        thousandSeparator={true}
                        prefix={"R"}
                        decimalScale={2}
                      />
                    </td>
                    <td>
                      <div
                        className={
                          "delivery-status " + (t.orderstatus || "")
                        }
                        style={{ fontSize: 11 }}
                      >
                        {t.orderstatus}
                      </div>
                    </td>
                    <td>
                      <div
                        className="vehicle-buttons-container"
                        style={{ display: "flex", gap: 4 }}
                      >
                        <Tooltip title="View trip details, comments and files">
                          <button
                            className="flat-button"
                            style={{ fontSize: 11 }}
                            onClick={() => onOpenTrip && onOpenTrip(t)}
                          >
                            <i className="mdi mdi-eye"></i> Open
                          </button>
                        </Tooltip>
                        {onDuplicateTrip ? (
                          <Tooltip title="Start a new booking pre-filled with this trip's route, goods and pricing">
                            <button
                              className="book-again-btn"
                              onClick={() => onDuplicateTrip(t)}
                            >
                              <i className="mdi mdi-refresh"></i> Book again
                            </button>
                          </Tooltip>
                        ) : null}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          )}
        </div>
      )}
    </Drawer>
  );
};

export default DriverTripsDrawer;
